import classNames from 'classnames'
import { type FC, type ReactNode } from 'react'
import styles from './EmailEditor.module.scss'

export interface EmailEnvelopeProps {
  fromName: ReactNode
  subject?: ReactNode
  joined?: boolean
}

const EnvelopeRow: FC<{ label: string; children: ReactNode }> = ({ label, children }) => (
  <div className='d-flex align-items-baseline gap-3'>
    <span className={classNames('flex-shrink-0 paragraph-small zocks-text-gray-400 text-uppercase', styles.envelopeLabel)}>{label}</span>
    <span className='paragraph-medium fw-normal zocks-text-gray-900 text-break mw-0'>{children}</span>
  </div>
)

export const EmailEnvelope: FC<EmailEnvelopeProps> = ({ fromName, subject, joined = false }) => (
  <div
    className={classNames('d-flex flex-column gap-2 px-3 zocks-bg-color-gray-100', joined ? ['pt-2 pb-1', styles.envelopeJoined] : 'py-2 zocks-border-0.75')}
  >
    <EnvelopeRow label='From'>
      <span>{fromName}</span> via Zocks · notifications@booking.zocks.com
    </EnvelopeRow>
    {subject !== undefined ? <EnvelopeRow label='Subject'>{subject}</EnvelopeRow> : null}
  </div>
)
